(function () {
    const GAP_REM = 1.5;

    function getGapInPixels() {
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        return GAP_REM * rem;
    }

    function getItems(slider) {
        return slider.querySelectorAll('.collection-list__item');
    }

    // Build an array of seam X positions (in slider scroll space): midpoints between adjacent item centers
    function getSeams(slider) {
        const items = getItems(slider);
        const seams = [];
        if (items.length < 2) return seams;

        for (let i = 0; i < items.length - 1; i++) {
            const a = items[i].getBoundingClientRect();
            const b = items[i + 1].getBoundingClientRect();

            const srect = slider.getBoundingClientRect();
            const centerA = (a.left - srect.left) + slider.scrollLeft + a.width / 2;
            const centerB = (b.left - srect.left) + slider.scrollLeft + b.width / 2;

            seams.push((centerA + centerB) / 2);
        }
        return seams;
    }

    function getNearestSeamIndex(slider, seams) {
        if (!seams.length) return 0;
        const viewportCenter = slider.scrollLeft + slider.clientWidth / 2;
        let best = 0, bestDist = Math.abs(seams[0] - viewportCenter);
        for (let i = 1; i < seams.length; i++) {
            const d = Math.abs(seams[i] - viewportCenter);
            if (d < bestDist) {
                best = i;
                bestDist = d;
            }
        }
        return best;
    }

    function scrollLeftForSeam(slider, seamX, seamIndex) {
        if (seamIndex === 0) {
            return 0;
        }

        return seamX - slider.clientWidth / 2;
    }

    function clamp(n, min, max) {
        return Math.max(min, Math.min(n, max));
    }

    /* ---------- responsive grid cols (<768px => 2) ---------- */
    function replaceGridColsClass(ulEl, newCols) {
        if (!ulEl) return;
        ulEl.className = ulEl.className.replace(/(?:^|\s)grid--\d+-col-desktop(?!\S)/g, '').trim();
        ulEl.classList.add('grid--' + String(newCols) + '-col-desktop');
    }

    function applyResponsiveCols(ulEl) {
        if (!ulEl) return;
        const def = parseInt(ulEl.getAttribute('data-default-cols') || '3', 10);
        const want = (window.innerWidth < 768) ? 2 : def;
        if (!ulEl.classList.contains('grid--' + String(want) + '-col-desktop')) {
            replaceGridColsClass(ulEl, want);
        }
    }

    function applyColsAndRefreshState(sliderUl) {
        applyResponsiveCols(sliderUl);
        refreshButtons(sliderUl);
    }

    /* ---------- buttons / counter ---------- */
    function updateCounter(sectionId, seamIdx) {
        const counter = document.getElementById('counter-current-' + sectionId);
        if (counter) counter.textContent = String(seamIdx + 1);
    }

    function refreshButtons(slider) {
        const sectionId = slider.id.replace('Slider-', '');
        const total = getItems(slider).length;
        const seams = getSeams(slider);
        const seamIdx = getNearestSeamIndex(slider, seams);
        const maxSeam = Math.max(0, total - 2);

        const comp = slider.closest('slider-component');
        const dPrev = comp && comp.querySelector('.desktop-arrow-btn--prev');
        const dNext = comp && comp.querySelector('.desktop-arrow-btn--next');
        if (dPrev) dPrev.disabled = seamIdx <= 0;
        if (dNext) dNext.disabled = seamIdx >= maxSeam;

        const prevBtn = comp && comp.querySelector('.slider-button--prev');
        const nextBtn = comp && comp.querySelector('.slider-button--next');
        if (prevBtn) prevBtn.disabled = seamIdx <= 0;
        if (nextBtn) nextBtn.disabled = seamIdx >= maxSeam;

        updateCounter(sectionId, Math.min(seamIdx, maxSeam));
    }

    function makeRafUpdater(fn) {
        let ticking = false;
        return function (...args) {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                fn.apply(this, args);
                ticking = false;
            });
        };
    }

    /* ---------- smooth scrolling ---------- */
    function smoothScrollTo(el, target, duration, onDone) {
        const start = el.scrollLeft;
        const dist = target - start;
        if (Math.abs(dist) < 1) {
            el.scrollLeft = target;
            onDone && onDone();
            return;
        }
        const t0 = performance.now();
        const ease = x => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;

        function tick(t) {
            const k = Math.min(1, (t - t0) / duration);
            el.scrollLeft = start + dist * ease(k);
            if (k < 1) requestAnimationFrame(tick); else onDone && onDone();
        }

        requestAnimationFrame(tick);
    }

    /* ---------- arrow navigation (moves by seams) ---------- */
    function slideCarousel(sectionId, direction) {
        const slider = document.getElementById('Slider-' + sectionId);
        if (!slider) return;
        const total = getItems(slider).length;
        if (total < 2) return;

        const seams = getSeams(slider);
        const maxSeam = Math.max(0, seams.length - 1);
        let seamIdx = getNearestSeamIndex(slider, seams);
        seamIdx = direction === 'next' ? clamp(seamIdx + 1, 0, maxSeam) : clamp(seamIdx - 1, 0, maxSeam);

        const targetLeft = scrollLeftForSeam(slider, seams[seamIdx], seamIdx);
        smoothScrollTo(slider, targetLeft, 160, () => refreshButtons(slider));
    }

    window.slideCarousel = slideCarousel;

    /* ---------- instant mouse drag with click suppression + snap-to-seam ---------- */
    function initInstantMouseDragWithSnap(slider) {
        slider.style.willChange = 'scroll-position';
        slider.style.touchAction = 'pan-x';
        slider.style.overscrollBehavior = 'contain';
        slider.addEventListener('dragstart', e => e.preventDefault());

        let isDown = false;
        let startX = 0;
        let startLeft = 0;
        let movedPx = 0;
        let suppressClick = false;

        // Prevent accidental link click right after a drag
        slider.addEventListener('click', function (e) {
            if (suppressClick) {
                e.stopPropagation();
                e.preventDefault();
                suppressClick = false;
            }
        }, true);

        const rafRefresh = makeRafUpdater(() => refreshButtons(slider));

        slider.addEventListener('mousedown', (e) => {
            if (e.button !== 0) return;
            isDown = true;
            startX = e.pageX;
            startLeft = slider.scrollLeft;
            movedPx = 0;

            slider.dataset.prevScrollBehavior = slider.style.scrollBehavior || '';
            slider.style.scrollBehavior = 'auto';
            slider.style.cursor = 'grabbing';
            slider.style.userSelect = 'none';

            const onMove = (ev) => {
                if (!isDown) return;
                const dx = ev.pageX - startX;
                movedPx = Math.max(movedPx, Math.abs(dx));
                slider.scrollLeft = startLeft - dx; // immediate
                rafRefresh();
                ev.preventDefault();
            };
            const onUp = () => {
                if (!isDown) return;
                isDown = false;

                slider.style.cursor = 'grab';
                slider.style.userSelect = '';
                slider.style.scrollBehavior = slider.dataset.prevScrollBehavior || '';

                window.removeEventListener('mousemove', onMove);
                window.removeEventListener('mouseup', onUp);

                if (movedPx > 5) {
                    suppressClick = true;
                    const seams = getSeams(slider);
                    if (seams.length) {
                        const idx = getNearestSeamIndex(slider, seams);
                        const targetLeft = scrollLeftForSeam(slider, seams[idx], idx);
                        smoothScrollTo(slider, targetLeft, 140, () => refreshButtons(slider));
                    }
                } else {
                    rafRefresh();
                }
            };

            window.addEventListener('mousemove', onMove, {passive: false});
            window.addEventListener('mouseup', onUp, {passive: true});
        }, {passive: true});

        let wheelTO;
        slider.addEventListener('wheel', (e) => {
            if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) return;
            e.preventDefault();
            slider.scrollLeft += e.deltaX;
            rafRefresh();

            clearTimeout(wheelTO);
            wheelTO = setTimeout(() => {
                const seams = getSeams(slider);
                if (!seams.length) return;
                const idx = getNearestSeamIndex(slider, seams);
                const targetLeft = scrollLeftForSeam(slider, seams[idx], idx);
                smoothScrollTo(slider, targetLeft, 280, () => refreshButtons(slider));
            }, 120);
        }, {passive: false});
    }

    /* ---------- init ---------- */
    function initCarousels() {
        const carousels = document.querySelectorAll('[id^="Slider-"]');
        const rafScrollUpdater = makeRafUpdater((slider) => refreshButtons(slider));

        carousels.forEach(slider => {
            const items = getItems(slider);
            if (items.length < 2) return;

            applyColsAndRefreshState(slider);
            initInstantMouseDragWithSnap(slider);

            slider.addEventListener('scroll', () => rafScrollUpdater(slider), {passive: true});
            refreshButtons(slider);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initCarousels();

        let rTO;
        window.addEventListener('resize', function () {
            clearTimeout(rTO);
            rTO = setTimeout(() => {
                const carousels = document.querySelectorAll('[id^="Slider-"]');
                carousels.forEach(slider => {
                    applyColsAndRefreshState(slider);
                    const seams = getSeams(slider);
                    if (seams.length) {
                        const currentIdx = getNearestSeamIndex(slider, seams);
                        if (currentIdx > 0) {
                            slider.scrollLeft = scrollLeftForSeam(slider, seams[currentIdx], currentIdx);
                        }
                    }
                    refreshButtons(slider);
                });
            }, 120);
        });
    });
})();
